import React from 'react';
import CartGlobalAvailabilityMessage from './CartGlobalAvailabilityMessage.jsx';
import {determineUndeliverableItems} from '@checkout/components/utils';

export default function LastCheckDeliverabilityHint({items, isDeliveryToPickUpLocationNotPossible, texts}) {
    const undeliverableItemCount = determineUndeliverableItems(items);

    if (undeliverableItemCount > 0 && !isDeliveryToPickUpLocationNotPossible) {
        return (
            <CartGlobalAvailabilityMessage
                items={items}
                texts={texts}
                undeliverableItemCount={undeliverableItemCount}
            />
        );
    } else {
        return null;
    }
}
